import { isDateObject } from 'src/utils/stateForm/helpers/cloneDeep/helpers/isDateObject';
import { isNullOrUndefined } from 'src/utils/stateForm/helpers/cloneDeep/helpers/isNullOrUndefined';

export const isObjectType = (value: unknown): value is object => typeof value === 'object';

export const isObject = <T extends object>(value: unknown): value is T =>
  !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
